import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import { ExpandMore } from '@material-ui/icons';
import { Link } from "react-router-dom";
import DriverHelpdeskForm from "../../components/Forms/DriverHelpdeskForm";
import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from '../../util/axios-portals';
import Spinner from "../../components/UI/Spinner";
import SimpleSnackbar from "../../components/UI/SimpleSnackbar";

const QuestionAndAnswer = ({ title, children }) => {
    return <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography style={{ fontWeight: 'bold'}}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ flexDirection: 'column' }}>
            {children}
        </AccordionDetails>
    </Accordion>
}

const FrequentlyAskedQuestions = ({ token }) => {
    const [videos, setVideos] = useState([]);
    const [isLoadingVideos, setIsLoadingVideos] = useState(false);
    const [isRequestSubmitted, setIsRequestSubmitted] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if(token) {
            setIsLoadingVideos(true);
            setError(null);
            const controller = new AbortController();
    
            axios.get('/help', {
                headers: {
                    'Authorization': `Bearer ${token}`, 
                    'Accept': 'application/json'
                }, 
                signal: controller.signal
            })
            .then(response => setVideos(response.data.help_videos || []))
            .catch(err => setError('Failed to retrieve video library'))
            .finally(() => setIsLoadingVideos(false));
    
            return () => controller.abort()
        }
    }, [axios, token, setIsLoadingVideos]);

    const handleDriverHelpdeskFormSubmit = useCallback((data) => {
        if(token) {
            setIsRequestSubmitted(false);
            setError(null);

            const controller = new AbortController();
    
            axios.post('/help/helpdesk', data, {
                headers: {
                    'Authorization': `Bearer ${token}`, 
                    'Accept': 'application/json'
                }, 
                signal: controller.signal
            })
            .then(response => setIsRequestSubmitted(true))
            .catch(err => setError('Failed to send helpdesk request'));
    
            return () => controller.abort()
        }
    }, [axios, token, setIsRequestSubmitted, setError]);

    return <Box p={2}>
        <Typography variant='h4' align='center'>FAQ</Typography>
        <Box maxWidth='700px' m='20px auto 0 auto'>
            <QuestionAndAnswer title='Paylocity'>
                <Typography variant='body2'>Please visit our <Link to='/paylocity'>Paylocity FAQ</Link> page for help on Paylocity</Typography>
            </QuestionAndAnswer>
            <QuestionAndAnswer title='Driver Helpdesk'>
                <Typography>Please fill out the below form to request help from our Driver Helpdesk team.</Typography>
                <Box w='100%'>
                    <DriverHelpdeskForm onSubmit={handleDriverHelpdeskFormSubmit} />
                </Box>
            </QuestionAndAnswer>
            { !isLoadingVideos && videos.map(({ title, path }) => {
                return <QuestionAndAnswer key={title} title={title}>
                    <Typography>A walkthrough can be found <a href={path} target="_blank">Here</a></Typography>
                </QuestionAndAnswer>
            })}
        </Box>
        { isLoadingVideos && <Spinner />}
        { isRequestSubmitted && <SimpleSnackbar open message='Request submitted successfully' />}
        { error && <SimpleSnackbar open message={error} />}
    </Box>
}

const mapStateToProps = state => {
    return {
        token: state.auth.token
    };
}

export default connect(mapStateToProps, null)(FrequentlyAskedQuestions);